export default __webpack_public_path__ + "static/media/play-keypad.af88a18c.svg";